import { Dialog, IconButton, Typography, withStyles } from "@material-ui/core";
import MuiDialogTitle from "@material-ui/core/DialogTitle";
import Fade from "@material-ui/core/Fade";
import CloseIcon from "@material-ui/icons/Close";
import { useState, useCallback, useRef, useEffect } from "react";
import ReactCrop from "react-image-crop";
import "react-image-crop/dist/ReactCrop.css";
import { useDispatch } from "react-redux";
import "../../styles/containers/Order.scss";
import CropContainer from "./CropContainer";
import Button from "../../components/Button";
const styles = (theme) => ({
  root: {
    margin: 0,
    padding: theme.spacing(2),
  },
  closeButton: {
    position: "absolute",
    right: theme.spacing(-2),
    top: theme.spacing(-2),
    backgroundColor: "#ededed",
    height: "30px",
    width: "30px",
    zIndex: "1",
  },
});
function OrderModal({ open, handleClose }) {
  const [upImg, setUpImg] = useState();
  const imgRef = useRef(null);
  const [openForm, setOpenForm] = useState(false);
  const inputFile = useRef(null);
  const onLoad = useCallback((img) => {
    imgRef.current = img;
  }, []);
  const [image, setImage] = useState(false);

  const onChangeImage = (e) => {
    if (e.target.files && e.target.files.length > 0) {
      setImage(e.target.files[0]);
      const reader = new FileReader();
      reader.addEventListener("load", () => setUpImg(reader.result));
      reader.readAsDataURL(e.target.files[0]);
    }
  };
  const handleRetake = () => {
    setImage(false);
    setOpenForm(false);
  };

  const onButtonClick = () => {
    inputFile.current.click();
  };
  const DialogTitle = withStyles(styles)((props) => {
    const { children, classes, onClose, ...other } = props;

    return (
      <MuiDialogTitle disableTypography className={classes.root}>
        {onClose ? (
          <IconButton
            aria-label="close"
            className={`${classes.closeButton} MuiIconButton-root`}
            onClick={onClose}
          >
            <CloseIcon />
          </IconButton>
        ) : null}
      </MuiDialogTitle>
    );
  });
  return (
    <div className="Order">
      <Dialog
        onClose={handleClose}
        open={open}
        maxWidth="md"
        fullWidth
        className={
          image
            ? "dialogbox MuiDialog-paper orderModalDialog"
            : "dialogbox MuiDialog-paper"
        }
      >
        <Fade in={open}>
          <>
            <DialogTitle id="customized-dialog-title" onClose={handleClose} />
            {!image && !openForm ? (
              <>
                <div
                  onClick={onButtonClick}
                  onChange={(e) => onChangeImage(e)}
                  className="InputDiv"
                >
                  <input
                    type="file"
                    id="file"
                    ref={inputFile}
                    style={{ display: "none" }}
                    accept="image/png, image/jpeg"
                  />
                  <Typography>Take /Upload Picture</Typography>
                </div>
              </>
            ) : image ? (
              <>
                <CropContainer
                  handleRetake={handleRetake}
                  openForm={openForm}
                  imgRef={inputFile}
                  onLoad={onLoad}
                  upImg={upImg}
                  mainImage={image}
                  imgRef={imgRef}
                  handleClose={handleClose}
                />
                {!openForm && (
                  <Button
                    className="modalButton"
                    onClick={() => setOpenForm(true)}
                    title={"Next"}
                    backgroundColor="#ededed"
                    color="#383838"
                    order={true}
                  />
                )}
              </>
            ) : null}
          </>
        </Fade>
      </Dialog>
    </div>
  );
}

export default OrderModal;
